import RegFormsLink from './RegFormsLink';
export default RegFormsLink;
